module.exports = __webpack_public_path__ + "img/finder.2699ac22.svg";